import { useContext as i } from "react";
import { WebsiteContext as r } from "../context/website.js";
import { getBaseWebsiteUrl as s } from "../helpers/getBaseWebsiteUrl.js";
function l(t) {
  var _i = i(r),
    o = _i.navigate,
    n = _i.websiteType;
  return t === n && o != null ? function (e) {
    return o(e);
  } : function (e) {
    window.location.href = "".concat(s(t)).concat(e);
  };
}
export { l as useWebsiteNavigate };